import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, Input, Snackbar, Modal } from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';
import { useHistory } from 'react-router-dom'
import { useSelector, shallowEqual } from 'react-redux'
import { SaveCoachService } from '../api/index'
import { RxCross2 } from 'react-icons/rx'
// import {} from "@material-ui/core"

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const AddServices = ({ setOpenAddService, fetchServicesList }) => {
    const { user } = useSelector(({ auth }) => auth, shallowEqual);
    const history = useHistory();
    const [snackbar, setSnackbar] = useState(() => ({
        isOpen: false,
        message: '',
        type: 'success'
    }))
    const [form, setForm] = useState(() => ({
        pending: false,
        category: '',
        title: '',
        subtitle: '',
        price: '',
        time: '',
        discription: '',
        userId: user.id
    }))

    const [date, setDate] = useState({
        days: '',
        hours: '',
        mintues: ''
    })

    const [openConfirmModal, setOpenConfirmModal] = useState(false)

    const [isConfirmed, setIsConfirmed] = useState(false);


    const handleSubmit = async (e) => {
        e.preventDefault();
        const { title, category, discription, price, subtitle, time } = form;

        if (title == '' || category == '' || discription == '' || price == '' || subtitle == "" || time == "") {
            setSnackbar((pre) => ({
                ...pre,
                isOpen: true,
                message: 'Please fill all fields.',
                type: 'error'
            }))
            return;
        }
        if(!isConfirmed){
            handleOpenModal();
            return;
        }

        try {
            setForm((pre) => ({ ...pre, pending: true }))
            await SaveCoachService(form);
            // history.push('/services');
            fetchServicesList();
            setOpenAddService(false);

        } catch (ex) {
            console.log(ex);
        } finally {
            setForm((pre) => ({ ...pre, pending: false }))
        }
    }

    const handleSubmitForm = async () =>{
        const { title, category, discription, price, subtitle, time } = form;

        if (title == '' || category == '' || discription == '' || price == '' || subtitle == "" || time == "") {
            setSnackbar((pre) => ({
                ...pre,
                isOpen: true,
                message: 'Please fill all fields.',
                type: 'error'
            }))
            return;
        }
        if(!isConfirmed){
            handleOpenModal();
            return;
        }else{
            setOpenConfirmModal(false)
        }

        try {
            setForm((pre) => ({ ...pre, pending: true }))
            await SaveCoachService(form);
            // history.push('/services');
            fetchServicesList();
            setOpenAddService(false);

        } catch (ex) {
            console.log(ex);
        } finally {
            setForm((pre) => ({ ...pre, pending: false }))
        }
    }
    useEffect(()=>{
        const { days, hours, mintues } = date
        if(days == 0 && hours == 0 && mintues == 0){
            setForm((pre)=>({
                ...pre,
                time: ''
            }))
            return ;
        }

        let time = '';
        if(days){
            time = `${days} days`
        }
        if(hours){
            time += `, ${hours} hours`
        }
        if(mintues){
            time += `, ${mintues} mintues`
        }
        setForm((pre)=>({
            ...pre,
            time: time
        }))
    }, [date])

    const handleOpenModal = () => {
        setOpenConfirmModal(true)
    };

    const handleChange = (e) => {
        e.persist();
        // console.log(e);
        setForm((pre) => ({
            ...pre,
            [e.target.name]: e.target.value
        }))
    }
    // const [list, setList] = useState([{ name: 'linkedIn', date: '09-12-2022' },{ name: 'linkedIn', date: '09-12-2022' },{ name: 'linkedIn', date: '09-12-2022' },{ name: 'linkedIn', date: '09-12-2022' },{ name: 'linkedIn', date: '09-12-2022' },{ name: 'linkedIn', date: '09-12-2022' },{ name: 'linkedIn', date: '09-12-2022' },{ name: 'linkedIn', date: '09-12-2022' },])
    return <>
        <Snackbar open={snackbar.isOpen} autoHideDuration={6000} onClose={() => { setSnackbar((pre) => ({ ...pre, isOpen: false })) }}>
            <Alert onClose={() => { setSnackbar((pre) => ({ ...pre, isOpen: false })) }} severity={snackbar.type}>
                {snackbar.message}
            </Alert>
        </Snackbar>
        <div className=' main1 bg-white rounded-lg overflow-hidden pb-5 mx-auto'>
            <div className='Abg-c d-flex justify-content-between align-items-start px-5 '>
                <div className='  pt-5'>
                    <h1 className='font3'>Add Service</h1>
                    <p>Share what are your offer, will share on your profile.</p>
                </div>
                <button disabled={form.pending} onClick={() => { setOpenAddService(false) }} className='bg-transparent border-0 btnSize  pt-2'><RxCross2 /></button>
            </div>

            <div className="container mt-5  px-5" >

                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-6 mt-5">
                            <label htmlFor="" className='font-weight-bold'>Category</label>
                            <select className='form-control' name='category' value={form.category} onChange={handleChange} placeholder='Category'>
                            <option value="" disabled selected>Category</option>
                            <option value="Resume">Resume</option>
                            <option value="Cover Letter">Cover Letter</option>
                            <option value="LinkedIn">LinkedIn</option>
                            <option value="Networking">Networking</option>
                            <option value="Job Search">Job Search</option>
                            <option value="Interview">Interview</option>
                            <option value="Negotiation">Negotiation</option>

                            </select>
                        </div>
                        <div className="col-6 mt-5">
                            
                            <label htmlFor="" className='font-weight-bold'>Title</label>
                            <input className='form-control' name='title' value={form.title} onChange={handleChange} type="text" placeholder='Title'/>
                            
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6 mt-5">
                            <label htmlFor="" className='font-weight-bold'>Sub Title</label>
                            <input className='form-control' value={form.subtitle} onChange={handleChange} name='subtitle' type="text" placeholder='Subtitle' />
                        </div>
                        <div className="col-6 mt-5">
                            <label htmlFor="" className='font-weight-bold'>Price $</label>
                            <div className="input-group">
                                <input className='form-control' min={0} value={form.price} onChange={handleChange} name='price' type="number" placeholder='Price' />
                                <div class="input-group-append">
                                    <span class="input-group-text">$</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-4 mt-5">
                            <label htmlFor="" className='font-weight-bold'>Days</label>
                            <input className='form-control'  value={date.days} onChange={(e)=>{ e.persist(); setDate((pre)=>({...pre, days: e.target.value}))}} name='time' type="number" min={0} placeholder='Days' />
                        </div>
                        <div className="col-4 mt-5">
                            <label htmlFor="" className='font-weight-bold'>Hours</label>
                            <input className='form-control' value={date.hours} onChange={(e)=>{ e.persist(); setDate((pre)=>({...pre, hours: e.target.value}))}} name='time' type="number" min={0} max={60} placeholder='Hours' />
                        </div>
                        <div className="col-4 mt-5">
                            <label htmlFor="" className='font-weight-bold'>Mintues</label>
                            <input className='form-control' value={date.mintues} onChange={(e)=>{ e.persist(); setDate((pre)=>({...pre, mintues: e.target.value}))}} name='time' type="number" min={0} max={60} placeholder='Mintues' />
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-lg-12 mt-5">
                            <label htmlFor="" className='font-weight-bold'>Description</label>
                            <textarea value={form.discription} onChange={handleChange} name="discription" id="" placeholder='Description' className='form-control' rows="7"></textarea>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 mt-5 d-flex justify-content-center">
                            {/* { form.pending ? <div class="spinner-border text-white mx-auto" role="status"></div> : 'Submit' } */}
                            {/* <button type='submit' className='form_btn bg-transparent' disabled={form.pending}>
                        Save as draft
                        </button> */}
                            <button disabled={form.pending} className='form_btn form_btn1 '>{form.pending ? <div style={{color: '#3783E7'}} class="spinner-border mx-auto" role="status"></div> : 'Save'}</button>
                        </div>
                    </div>
                </form>

            </div>

        </div>
        <Modal
            open={openConfirmModal}
            onClose={() => {
                setOpenConfirmModal(false);
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            BackdropProps={{ onClick: () => {} }}
        >
            <div className=' main1 bg-white rounded-lg overflow-hidden pb-5 mx-auto'>
            <div className='Abg-c d-flex justify-content-between align-items-start px-5 '>
                <div className='  pt-5'>
                    <h1 className='font3'>Terms</h1>
                    <p>Please agree terms before continue.</p>
                </div>
                <button onClick={() => { setOpenConfirmModal(false) }} className='bg-transparent border-0 btnSize  pt-2'><RxCross2 /></button>
            </div>

            <div className="container mt-5  px-5" >
                <div className="row">
                    <div className="col-12 mt-5 d-flex justify-content-center">
                            {/* { form.pending ? <div class="spinner-border text-white mx-auto" role="status"></div> : 'Submit' } */}
                            {/* <button type='submit' className='form_btn bg-transparent' disabled={form.pending}>
                        Save as draft
                        </button> */}
                            <p>Upon entering ${form.price}, a 2% platform fee will be deducted, resulting in a net amount of ${form.price - (2/100*form.price)} credited to your account.</p>
                        </div>
                </div>
                
                <div className="row">
                    <div className="col-12 mt-5 d-flex">
                            {/* { form.pending ? <div class="spinner-border text-white mx-auto" role="status"></div> : 'Submit' } */}
                            {/* <button type='submit' className='form_btn bg-transparent' disabled={form.pending}>
                        Save as draft
                        </button> */}
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" checked={isConfirmed} onChange={() => {setIsConfirmed(!isConfirmed)}} id="agreeCheckbox" />
                                <label class="form-check-label" for="agreeCheckbox">I Agree</label>
                            </div>
                        </div>
                </div>
                    <div className="row">
                        <div className="col-12 mt-5 d-flex justify-content-center">
                            {/* { form.pending ? <div class="spinner-border text-white mx-auto" role="status"></div> : 'Submit' } */}
                            {/* <button type='submit' className='form_btn bg-transparent' disabled={form.pending}>
                        Save as draft
                        </button> */}
                            <button disabled={!isConfirmed} onClick={handleSubmitForm} className='form_btn form_btn1 '>Continue</button>
                        </div>
                    </div>

            </div>

        </div>
        </Modal>
    </>
}

export default AddServices;